import { render, staticRenderFns } from "./orderMontyStatistic.vue?vue&type=template&id=767c5fd5&scoped=true"
import script from "./orderMontyStatistic.vue?vue&type=script&lang=js"
export * from "./orderMontyStatistic.vue?vue&type=script&lang=js"
import style0 from "./orderMontyStatistic.vue?vue&type=style&index=0&id=767c5fd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767c5fd5",
  null
  
)

export default component.exports